// کلیدهای Query صفحات پیکربندی CFG (AP-PLT-05).
export const cfgKeys = {
  all: (tenantId: string | undefined) => ['configuration', 'settings', 'all', tenantId] as const,
  history: (tenantId: string | undefined, key: string) =>
    ['configuration', 'settings', 'history', key, tenantId] as const,
  modules: (tenantId: string | undefined) => ['configuration', 'modules', tenantId] as const,
  customFields: (tenantId: string | undefined, entity: string) =>
    ['configuration', 'custom-fields', entity, tenantId] as const,
  // AP-CFG-01.
  packs: (tenantId: string | undefined) => ['configuration', 'specialty-packs', tenantId] as const,
  packPreview: (tenantId: string | undefined, code: string) => ['configuration', 'specialty-packs', 'preview', code, tenantId] as const,
  packInstall: (tenantId: string | undefined, code: string) => ['configuration', 'specialty-packs', 'install', code, tenantId] as const,
  samples: (tenantId: string | undefined) => ['configuration', 'sample-items', tenantId] as const,
  parameterSets: (tenantId: string | undefined) => ['configuration', 'parameter-sets', tenantId] as const,
  rules: (tenantId: string | undefined) => ['configuration', 'clinical-rules', tenantId] as const,
  calculators: (tenantId?: string) => ['configuration', 'calculators', tenantId] as const,
};

/** کتابخانه محاسبه‌گر مستأجر (US-CFG-053). */
export const SCR_STAFF_1206 = 'SCR-STAFF-1206';
